import { observer } from 'mobx-react-lite';
import {
  GameStructure,
  GameSection,
  TableFooter,
  useTranslation,
  parseNumberByPrecision, useUserSettingsStore, iframeService, applicationStore,
} from '@pascal/pascal-core';
import { HeaderContent } from '../../conatiners/header';
import { WebGameScene } from '../webGameScene';
import { GamePad } from '../../components/gamePad';
import { Popups } from '../../components/popups/popups';
import { gameStore } from '../../module/store/gameStore';
import { soundService } from '../../module/services/SoundService';
import { useEffect } from 'react';
import { gameService } from '../../module/gameLiveConnection/gameService';
import { configStore } from '../../module/store/configStore';
import { PlayingGameMode } from '../../enums/PlayingGameMode';
import { gameLiveConnection } from '../../module/gameLiveConnection/gameLiveConnection';

export const WebGame = observer(() => {
  const { isMusicOn } = useUserSettingsStore();

  useEffect(() => {
    soundService.muteMusic(!isMusicOn);
    if (isMusicOn) {
      soundService.playMusic();
    } else {
      soundService.stopMusic();
    }
  }, [isMusicOn]);

  const t = useTranslation();
  return (
    <GameStructure>
      <HeaderContent />
      <GameSection haveNotification={true} translationValues={{}}>
        <div className='web-mines-game-wrapper'>
          <WebGameScene />
          <GamePad />
          <Popups />
        </div>
      </GameSection>
      <TableFooter
        totalBet={parseNumberByPrecision(gameStore.amount, 1)}
        additionalCountChecker={false}
        demoSwitcherAdditionalFunction={() => {
          gameLiveConnection.sendClose().then(() => {
            gameService.resetResults()
            configStore.setMode(PlayingGameMode.Real)
          })
        }
        }
      />
    </GameStructure>
  );
});